<template>
  <div class="magazine-view">
    <!-- Toast powodzenia -->
    <div v-if="showToast" class="success-toast">
      {{ toastMessage }}
    </div>

    <!-- HEADER -->
    <div class="page-header">
      <div class="header-left">
        <router-link to="/add-magazine-item">
          <button class="btn btn-primary">
            + Dodaj przedmiot
          </button>
        </router-link>
      </div>

      <input
        v-model="search"
        class="search-input"
        type="search"
        placeholder="Wyszukaj przedmiot..."
      />
    </div>

    <!-- SUMMARY -->
    <div class="summary">
      <div class="summary-item">
        <span class="summary-label">Liczba przedmiotów</span>
        <span class="summary-value">{{ filteredItems.length }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Łączna ilość</span>
        <span class="summary-value">{{ totalQuantity }}</span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Niski stan</span>
        <span class="summary-value low-stock-value">{{ lowStockCount }}</span>
      </div>
    </div>

    <!-- TABLE -->
    <div class="table-container">
      <table class="magazine-table">
        <thead>
          <tr>
            <th>Nazwa przedmiotu</th>
            <th>Ilość</th>
            <th>Ostatnia edycja</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in filteredItems"
            :key="item.id"
            class="item-row"
            :class="{ 'row-low-stock': isLowStock(item) }"
            @click="openMagazineModal(item)"
          >
            <td>
              <div class="item-cell">
                <span class="icon">
                  📦
                </span>
                <div class="item-info">
                  <span class="name">{{ item.title }}</span>
                  <span class="type">Magazyn</span>
                </div>
              </div>
            </td>
            <td @click.stop>
              <div v-if="editingItemId === item.id" class="quantity-edit-container">
                <input
                  v-model="editingQuantity"
                  type="number"
                  min="0"
                  class="quantity-input"
                  @blur="saveQuantity(item)"
                  @keyup.enter="saveQuantity(item)"
                  @keyup.esc="cancelEdit"
                  ref="quantityInput"
                />
                <button class="btn-save-quantity" @click="saveQuantity(item)" title="Zapisz">
                  ✓
                </button>
                <button class="btn-cancel-quantity" @click="cancelEdit" title="Anuluj">
                  ✕
                </button>
              </div>
              <span
                v-else
                class="quantity-badge editable"
                :class="{ 'low-stock': isLowStock(item) }"
                @click.stop="startEdit(item)"
                title="Kliknij aby edytować ilość"
              >
                {{ item.quantity }} szt.
              </span>
            </td>
            <td>
              <span class="date-badge">
                {{ lastEdit(item.lastEdit) }}
              </span>
            </td>
            <td>
              <span v-if="isLowStock(item)" class="badge-low-stock">⚠️ Niski stan</span>
              <span v-else class="badge-ok">✓ OK</span>
            </td>
            <td>
              <button class="btn-details" @click.stop="openMagazineModal(item)">
                Szczegóły
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <magazine-modal @closeModal="closeModal()" :item="item"></magazine-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import MagazineModal from "../components/MagazineModal";

export default {
  data() {
    return {
      //   installation: {
      //     brand: "",
      //     model: "",
      //     plate: "",
      //     vin: "",
      //     year: "",
      //     imageUrl: "",
      //   },
      //   openForm: false,
      search: "",
      item: "",
      costsChecked: false,
      paymentsChecked: false,
      phoneSearch: "",
      today: new Date("yyyy-mm-dd"),
      editingItemId: null,
      editingQuantity: null,
      showToast: false,
      toastMessage: "",
    };
  },
  components: {
    "magazine-modal": MagazineModal,
  },

  computed: {
    ...mapState(["userProfile", "magazine"]),
    formatDate() {
      var d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    // sortedPayments() {
    //   function compare(a, b) {
    //     return new Date(b.date) - new Date(a.date);
    //   }
    //   let arr = this.allPayments;

    //   return arr.sort(compare);
    // },

    // allPayments() {
    //   return this.payments.concat(this.paymentsArchive);
    // },

    filteredItems() {
      return this.magazine.filter((item) => {
        if (item.title.toUpperCase().includes(this.search.toUpperCase())) {
          return item;
        } else if (item.quantity.toString().includes(this.search)) {
          return item;
        }
      });
    },
    totalQuantity() {
      return this.filteredItems.reduce((sum, item) => {
        const qty = parseInt(item.quantity) || 0;
        return sum + qty;
      }, 0);
    },
    lowStockCount() {
      return this.filteredItems.filter(item => this.isLowStock(item)).length;
    },
  },
  methods: {
    startEdit(item) {
      this.editingItemId = item.id;
      this.editingQuantity = item.quantity;
      this.$nextTick(() => {
        const input = this.$refs.quantityInput;
        if (input) {
          if (Array.isArray(input)) {
            input[0].focus();
            input[0].select();
          } else {
            input.focus();
            input.select();
          }
        }
      });
    },
    cancelEdit() {
      this.editingItemId = null;
      this.editingQuantity = null;
    },
    async saveQuantity(item) {
      if (this.editingQuantity === null || this.editingQuantity === '') {
        this.cancelEdit();
        return;
      }

      const newQuantity = parseInt(this.editingQuantity);
      if (isNaN(newQuantity) || newQuantity < 0) {
        alert('Wprowadź poprawną ilość (liczba >= 0)');
        return;
      }

      if (newQuantity === parseInt(item.quantity)) {
        this.cancelEdit();
        return;
      }

      try {
        await this.$store.dispatch("updateMagazineItem", {
          id: item.id,
          notice: item.notice || '',
          quantity: newQuantity,
          title: item.title,
        });
        
        this.showToastNotification(`✓ Ilość zaktualizowana: ${newQuantity} szt.`);
        this.cancelEdit();
      } catch (error) {
        console.error('Błąd podczas aktualizacji ilości:', error);
        alert('Wystąpił błąd podczas zapisywania. Spróbuj ponownie.');
      }
    },
    showToastNotification(message) {
      this.toastMessage = message;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
    isLowStock(item) {
      const qty = parseInt(item.quantity) || 0;
      return qty <= 10; // Niski stan poniżej lub równy 10
    },
    openMagazineModal(event) {
      console.log(event);
      this.$modal.show("magazine-modal");
      this.item = event;
      // Prevent navigating to narrower view (default vue-cal behavior).
      // e.stopPropagation();
    },
    closeModal() {
      this.$modal.hide("magazine-modal");
    },
    lastEdit(e) {
      return new Date(e.seconds * 1000).toLocaleDateString();
    },
    getData() {
      this.$store.dispatch("getMagazine");
    },
  },
  mounted() {
    // Pobierz dane tylko jeśli nie ma żadnych elementów w magazynie
    if (!this.magazine || this.magazine.length === 0) {
      const limits = this.$store.state.userProfile.limits;
      const limit = (limits && limits.magazine) || 1000;
      this.$store.dispatch("getMagazine", { limit });
    }
  },
  beforeDestroy() {
    // NIE czyścimy danych - pozwalamy im zostać w store
    // this.$store.commit("unsubscribeListener", "magazine");
  },
};
</script>
<style scoped>
.magazine-view {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* HEADER */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 24px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.search-input {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  min-width: 300px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

/* SUMMARY */
.summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.summary-item {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  overflow: hidden;
}

.summary-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.summary-label {
  font-size: 13px;
  color: #6c757d;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-left: 12px;
}

.summary-value {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-left: 12px;
}

.summary-value.low-stock-value {
  background: linear-gradient(135deg, #ffc107 0%, #ff9800 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* TABLE */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

.magazine-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.magazine-table thead {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.magazine-table th {
  padding: 18px 20px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid #dee2e6;
  position: sticky;
  top: 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  z-index: 10;
}

.magazine-table tbody tr {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.magazine-table tbody tr::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #e9ecef 50%, transparent 100%);
}

.magazine-table tbody tr:hover {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  transform: scale(1.01);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  z-index: 1;
}

.magazine-table td {
  padding: 20px;
  font-size: 14px;
  color: #2c3e50;
  vertical-align: middle;
}

.item-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.icon {
  font-size: 24px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
}

.magazine-table tbody tr:hover .icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scale(1.1);
}

.item-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.item-info .name {
  font-weight: 600;
  color: #2c3e50;
  font-size: 15px;
}

.item-info .type {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-align: left;
}

.quantity-badge {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-block;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.quantity-badge.editable {
  cursor: pointer;
  position: relative;
}

.quantity-badge.editable:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transform: scale(1.05);
}

.quantity-badge.editable::after {
  content: '✏️';
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  opacity: 0;
  transition: all 0.3s ease;
}

.quantity-badge.editable:hover::after {
  opacity: 1;
  right: -24px;
}

.quantity-badge.low-stock {
  color: #856404;
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
}

.quantity-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.quantity-input {
  width: 100px;
  padding: 8px 12px;
  border: 2px solid #667eea;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  transition: all 0.3s ease;
  outline: none;
}

.quantity-input:focus {
  border-color: #764ba2;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.btn-save-quantity,
.btn-cancel-quantity {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-save-quantity {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
}

.btn-save-quantity:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.btn-cancel-quantity {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
}

.btn-cancel-quantity:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

.success-toast {
  position: fixed;
  top: 80px;
  right: 20px;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(40, 167, 69, 0.4);
  z-index: 10000;
  animation: slideIn 0.3s ease-out;
  font-weight: 600;
  font-size: 15px;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.date-badge {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 6px 14px;
  border-radius: 8px;
  display: inline-block;
  white-space: nowrap;
}

.row-low-stock {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.05) 0%, rgba(255, 193, 7, 0.02) 100%);
  border-left: 4px solid #ffc107;
}

.row-low-stock:hover {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 193, 7, 0.05) 100%);
}

.badge-low-stock {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
  color: #856404;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  border-left: 3px solid #ffc107;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.2);
}

.badge-ok {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  border-left: 3px solid #28a745;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.2);
}

.btn-details {
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.btn-details:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-details:active {
  transform: translateY(0);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .magazine-view {
    padding: 12px;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
  }

  .header-left {
    flex-direction: column;
    width: 100%;
  }

  .search-input {
    min-width: 100%;
  }

  .table-container {
    overflow-x: auto;
    border-radius: 8px;
  }

  .magazine-table {
    min-width: 800px;
  }

  .magazine-table th,
  .magazine-table td {
    padding: 12px;
    font-size: 13px;
  }
}
</style>
